module.exports = __webpack_public_path__ + "img/anmat.a382bf59.png";